import React from 'react';
import Map from '../components/Map';
import Address from '../components/Address';
import styled from 'styled-components';

const AddressContainer = styled.section`

  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const MapContainer = styled.div`
  padding: 0;

  @media (min-width: 768px) {
    padding-left: 3rem;
  }
`;


const Contact = ({ data }) => {

  const { contactDetails } = data.site.siteMetadata;
  const { address, telephoneNumber, emailAddress, socialMedia } = contactDetails;

  return (
    <section>
      <h1>Contact Ian Willmott</h1>
      <h2>Address</h2>
      <AddressContainer>
        <Address address={address} />
        <MapContainer>
          <Map />
        </MapContainer>
      </AddressContainer>
      <h2>Telephone</h2>
      <a href={`tel:${telephoneNumber}`}>{ telephoneNumber }</a>
      <h2>Email Address</h2>
      <a href={`mailto:${emailAddress}`}>{ emailAddress }</a>
      <h2>Social Media</h2>
      <div>
        <a
         href="https://twitter.com/backsgetbetter?ref_src=twsrc%5Etfw"
          target="_blank"
          rel="noopener noreferrer">Twitter</a>
      </div>
      <div>
        <a target="_blank" rel="nopener noreferrer" href={socialMedia.facebook}>Facebook</a>
      </div>
    </section>
  );
};

export default Contact;

export const query = graphql`
  query ContactPageQuery {
    site {
      siteMetadata {
        contactDetails {
          address
          telephoneNumber
          emailAddress
          socialMedia {
            twitter
            facebook
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/contact.js